'use client';

import { useTranslations } from 'next-intl';

import type { GenderStep } from '@/modules/authentication/view-model';

import { GenderEnum } from '@packages/contracts';
import { Form } from '@packages/hook-form-wrapper';

export const Gender = () => {
	const t = useTranslations('authentication.registration.form.gender');
	const options = GenderEnum.options.map(value => ({
		label: t('enum', { gender: value }),
		value,
	}));

	return (
		<Form.RadioGroup<GenderStep> gap={8} name="gender" options={options} />
	);
};
